export default __webpack_public_path__ + "static/media/fundraiseStartCampaign.2b68e54f.png";